import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    locationModal: {
        open: false,
        leadDetails: '',
    },
    invitedAgentModal: {
        open: false,
        id: '',
    },
    leadModal: {
        open: false,
        id: '',
    },
    leadComModal: {
        open: false,
        id: '',
    },
};

const icaSlice = createSlice({
    name: 'ica',
    initialState,
    reducers: {
        OPEN_LEAD_COM_MODEL: (state, action) => {
            return {
                ...state,
                leadComModal: {
                    open: true,
                    id: action.payload,
                },
            };
        },
        CLOSE_LEAD_COM_MODEL: (state, action) => {
            return {
                ...state,
                leadComModal: {
                    open: false,
                    id: '',
                },
            };
        },
        OPEN_LEAD_MODEL: (state, action) => {
            return {
                ...state,
                leadModal: {
                    open: true,
                    id: action.payload,
                },
            };
        },
        CLOSE_LEAD_MODEL: (state, action) => {
            return {
                ...state,
                leadModal: {
                    open: false,
                    id: '',
                },
            };
        },
        OPEN_INVITE_MODEL: (state, action) => {
            return {
                ...state,
                invitedAgentModal: {
                    open: true,
                    id: action.payload,
                },
            };
        },
        CLOSE_INVITE_MODEL: (state, action) => {
            return {
                ...state,
                invitedAgentModal: {
                    open: false,
                    id: '',
                },
            };
        },
        OPEN_RE_ASSING_MODAL: (state, action) => {
            return {
                ...state,
                locationModal: {
                    open: true,
                    leadDetails: action.payload,
                },
            };
        },
        CLOSE_RE_ASSING_MODAL: (state) => {
            return {
                ...state,
                locationModal: {
                    open: false,
                    leadDetails: '',
                },
            };
        },
    },
});

export const {
    OPEN_LEAD_COM_MODEL,
    CLOSE_LEAD_COM_MODEL,
    OPEN_LEAD_MODEL,
    CLOSE_LEAD_MODEL,
    OPEN_INVITE_MODEL,
    CLOSE_INVITE_MODEL,
    OPEN_RE_ASSING_MODAL,
    CLOSE_RE_ASSING_MODAL,
} = icaSlice.actions;

export default icaSlice.reducer;
